// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"b8ba6c73","787":"1ccb5436","905":"6b9db5bc"}[chunkId] + ".chunk.js";
};